import { Box, useMediaQuery } from '@chakra-ui/react';

const BorderBox = ({ children }) => {
  const [isXS] = useMediaQuery('(max-width:480px)');

  return (
    <>
      {isXS ? (
        <Box>{children}</Box>
      ) : (
        <Box
          border="1px solid"
          borderColor="GRAY"
          borderRadius="4px"
          padding="16px"
          margin="0"
        >
          {children}
        </Box>
      )}
    </>
  );
};

export default BorderBox;
